import React from "react";
import Cta from "../cta/cta";

const FeaturesCta = () => {
  return (
    <Cta
      heading="Ready to experience the difference?"
      firstCta="/signup"
      firstCtaText="Subscribe Now"
      secondCta="/contact-us"
      secondCtaText="Contact us"
    />
  );
};

export default FeaturesCta;
